export const darkTheme = {
  bg: "#0a0e17",
  bgLight: "#0f1629",
  primary: "#00d4aa",
  accent: "#6366f1",
  text_primary: "#f1f5f9",
  text_secondary: "#94a3b8",
  card: "#111827",
  card_light: "#1e293b",
  button: "#00d4aa",
  white: "#FFFFFF",
  black: "#000000",
  border: "rgba(0, 212, 170, 0.25)",
  gradient: "linear-gradient(135deg, #00d4aa 0%, #6366f1 100%)",
  glow: "rgba(0, 212, 170, 0.15)",
};

export const lightTheme = {
  bg: "#f8fafc",
  bgLight: "#f1f5f9",
  primary: "#0891b2",
  accent: "#4f46e5",
  text_primary: "#0f172a",
  text_secondary: "#64748b",
  card: "#ffffff",
  card_light: "#ffffff",
  button: "#0891b2",
  white: "#FFFFFF",
  black: "#000000",
  border: "rgba(8, 145, 178, 0.3)",
  gradient: "linear-gradient(135deg, #0891b2 0%, #4f46e5 100%)",
  glow: "rgba(8, 145, 178, 0.12)",
};
